import { debounce } from "lodash";
import { Overlay } from "../overlay";
import { ChunkStatistics, Viewer } from "../viewer";
import './loadingProgress.less'
import i18n from "../i18n/i18n";

let hasInstance:any = false
export class LoadingProgress extends Overlay {
  progress:HTMLProgressElement
  timer:any = null
  chunkStatistics: ChunkStatistics
  constructor(viewer: Viewer) {
    super({hasInstance});
    if (hasInstance) {
      return
    }
    hasInstance = true
    const {chunkStatistics, layerManager} = viewer
    this.chunkStatistics = chunkStatistics
    
    this.container.classList.remove('overlay')
    this.content.classList.add('state_operate_dialog','progress_dialog');
    this.content.style.minHeight = '5.125rem';
    this.content.style.top = 'auto'
    this.content.style.bottom = '0rem'

    const label = document.createElement('div')
    label.classList.add('label')
    const progressLabel = document.createElement('span')
    progressLabel.innerText = i18n.Loading
    const progressValue = document.createElement('span')
    label.appendChild(progressLabel)
    label.appendChild(progressValue)
    
    const progress = this.progress = document.createElement('progress')
    progress.max = 0.1
    progress.value = 0
    progressValue.innerHTML = `0%`
    this.content.appendChild(label)
    this.content.appendChild(this.progress)

    // 使用setTimeout实现setInterveal的功能
    function setInterveal(fn:Function, time:number) {
      let timer:any
      function loop() {
        fn()
        timer = setTimeout(loop, time)
      }
      loop()
      return function() {
        clearTimeout(timer)
      }
    }
    const that = this
    let closeTimer:any
    let clearTimer:any
    if(!clearTimer) clearTimer = setInterveal(update, 200);
    function update() {
      const {totalPresent, totalChunk} = chunkStatistics
        totalPresent.value = 0
        totalChunk.value = 0
        for (const layer of layerManager.managedLayers) {
          if (layer.visible && layer?.chunkStatistics) {
            const {chunkStatistics:layerChunkStatistics} = layer
            totalPresent.value += layerChunkStatistics.totalPresent || 0
            totalChunk.value += layerChunkStatistics.totalChunk || 0
          }
        }
        if(totalChunk.value) {
          progress.max = totalChunk.value
          progress.value = totalPresent.value
          progressValue.innerHTML = `${ parseInt(`${totalPresent.value / totalChunk.value * 100}`) }%`
        }
        if (totalChunk.value === totalPresent.value) {
          // 多图层异步加载，需加防抖，减少多次生成关闭进度条
          debounce(()=> {
            if (!closeTimer) {
              // 进度达到100%后延时1500ms关闭
              closeTimer = setTimeout(() => {
                that.dispose();
                document.getElementById('neuroglancer-container')?.focus();
                hasInstance = false
                closeTimer = null
                // clearTimer()
                clearTimer = null
              }, 1500)
            }
          }, 100)()
        }
    }
  }
}
